import gql from 'graphql-tag';

export const GET_ANSWERS = gql`
  query($questionIds: [Int]!) {
    questionAnswer {
      getAnswersByQuestionIds(questionIds: $questionIds) {
        contentSnippetQuestionId
        ... on QuestionAnswerCheckboxType {
          selectedAnswers {
            questionResponseCheckboxId
          }
        }
        ... on QuestionAnswerRadioType {
          questionResponse {
            id
            label
          }
        }
      }
    }
  }
`;
